module.exports = __webpack_public_path__ + "img/arrow-left.05a9a11b.svg";